import {strEnum} from "../../types";


export const MP_LISTING_ORG_TYPE = strEnum([
    "None",
    "Provider",
    "Listing",
    "Consumer"]
);
export type MP_LISTING_ORG_TYPE = keyof typeof MP_LISTING_ORG_TYPE | string;
/**
 * Mapping info backend <=> frontend
 * State/M |  Backend                       |   FrontEnd
 * -----------------------------------------------------------------------------------------
 * PROV:   | "PrivatelyAvailable"           | new TCIMarketplaceListingStatus("PrivatelyAvailable");
 * PROV:   | "PendingApproval"              | new TCIMarketplaceListingStatus("PendingApproval");
 * PROV:   | "RejectedPublicListing"        | new TCIMarketplaceListingStatus("RejectedPublicListing");
 * PROV:   | "WithdrawnPendingApproval"     | new TCIMarketplaceListingStatus("WithdrawnPendingApproval");
 * PROV:   | "ApprovedPublicListing"        | new TCIMarketplaceListingStatus("ApprovedPublicListing");
 * PROV:   | "PubliclyAvailable"            | new TCIMarketplaceListingStatus("PubliclyAvailable");
 * CONS:   | "ListingRequest"              | new TCIMarketplaceListingStatus("ListingRequest");
 * CONS:   | "PendingRequest"              | new TCIMarketplaceListingStatus("PendingRequest");
 * CONS:   | "RequestApproved"             | new TCIMarketplaceListingStatus("RequestApproved");
 * CONS:   | "RequestRejected"             | new TCIMarketplaceListingStatus("RequestRejected");
 * CONS:   | "AccessRevoked"               | new TCIMarketplaceListingStatus("AccessRevoked");
 * CONS:   | "ListingGet"                  | new TCIMarketplaceListingStatus("ListingGet");
 * CONS:   | "ListingDisabled"             | new TCIMarketplaceListingStatus("ListingDisabled");
 * CONS:   | "ListingEnabled"              | new TCIMarketplaceListingStatus("ListingEnabled");
 * CONS:   | "Access-Revoke-Acknowledged"   | new TCIMarketplaceListingStatus("Access-Revoke-Acknowledged");
 */
export const MP_LISTING_STATUS = strEnum([
    "PrivatelyAvailable",
    "PendingApproval",
    "RejectedPublicListing",
    "WithdrawnPendingApproval",
    "ApprovedPublicListing",
    "PubliclyAvailable",
    "ListingRequest",
    "PendingRequest",
    "RequestApproved",
    "RequestRejected",
    "AccessRevoked",
    "ListingGet",
    "ListingDisabled",
    "ListingEnabled",
    "AccessRevokeAcknowledged"
]);
export type MP_LISTING_STATUS = keyof typeof MP_LISTING_STATUS;

export const MP_LISTING_TYPE = strEnum(["Connector", "Application", "Accelerator"]);
export type MP_LISTING_TYPE = keyof typeof MP_LISTING_TYPE;

export const MP_LISTING_STATE = strEnum(["Draft", "Published", "Unknown"]);
export type MP_LISTING_STATE = keyof typeof MP_LISTING_STATE;

export const MP_LISTING_PRICING_OPTIONS = strEnum(["Paid", "Free"]);
export type MP_LISTING_PRICING_OPTIONS = keyof typeof MP_LISTING_PRICING_OPTIONS;


export const MP_LISTING_ACTIONS = strEnum([
    "GET", // implemented in POST Access
    "REQUEST", // implemented in POST Access
    "INSTALL", // implemented in POST Access
    "UNINSTALL", // implemented in POST Access
    "ACKNOWLEDGE_REVOKED", // implemented in POST Access
    "ACKNOWLEDGE_REJECT", // implemented in PUT Access
    "APPROVE_REQUEST", // implemented in PUT Access
    "REJECT_REQUEST", // implemented in PUT Access
    "REVOKE_ACCESS", // implemented in PUT Access
    "UNREVOKE_ACCESS", // implemented in PUT Access
    "SUBMIT_FOR_APPROVAL", // implemented in POST /approval
    "WITHDRAW", // implemented in DELETE /approval
    "VISIBILITY_PRIVATE", // implemented in POST /visibility?visibility=private
    "VISIBILITY_PUBLIC" // implemented in POST /visibility?visibility=public
]);
export type MP_LISTING_ACTIONS = keyof typeof MP_LISTING_ACTIONS;

// export const MP_ACCESS_STATUS = strEnum(["granted", "rejected", "revoked", "unrevoked", "acknowledgerevoked"]);
// export type MP_ACCESS_STATUS = keyof typeof MP_ACCESS_STATUS;

export const MP_VISIBILITY = strEnum(["private", "public"]);
export type MP_VISIBILITY = keyof typeof MP_VISIBILITY;

export interface IMPAssetTag {
    /**
     * tag name which is unique globally
     */
    name: string;
    /**
     * the number of assets to which this tag is attached
     */
    assetCount?: number;
}

/**
 *
 */
export interface IMPAssetTagsList {
    tags: IMPAssetTagsInfo[];
}

/**
 *
 */
export interface IMPSimplifiedAssetTagsList {
    // name = tag name, string[] = an array of asset ids
    [name: string]: string[];
}

/**
 *
 */
export interface IMPAssetTagsInfo {
    id: string;
    name: string;
    userName: string;
    subscriptionId: string;
    agentIds?: string[];
    appIds?: string[];
    connectionIds?: string[];
    marketplaceIds?: string[];
}

// tslint:disable-next-line:no-empty-interface
export interface IMPApplicationTags extends IMPAssetTagsInfo {
}

// tslint:disable-next-line:no-empty-interface
export interface IMPConnectionTags extends IMPAssetTagsInfo {
}

// tslint:disable-next-line:no-empty-interface
export interface IMPListingTags extends IMPAssetTagsInfo {
}

/**
 * Asset Tag mapping for the gsbc + uid + tagId
 */
export interface IMPOrgAssetInfo {
    /**
     * application tags
     */
    applications?: IMPApplicationTags;
    /**
     * connection tags
     */
    connections?: IMPConnectionTags;
    /**
     * Listing tags
     */
    listings?: IMPListingTags;
}

/**
 * IMPLikes
 */
export interface IMPLikes {
    /**
     * like
     */
    likes: number;
}

/**
 * IMPLike
 */
export interface IMPLike {
    /**
     * true | false
     */
    like: boolean;
    /**
     * user comments
     */
    comment?: string;
}

/**
 * IMPRating
 */
export interface IMPRating extends IMPLikes {

    /**
     * number of ticks for this rating 1
     */
    r1_count: number;
    /**
     * number of ticks for this rating 2
     */
    r2_count: number;
    /**
     * number of ticks for this rating 3
     */
    r3_count: number;
    /**
     * number of ticks for this rating 4
     */
    r4_count: number;
    /**
     * number of ticks for this rating 5
     */
    r5_count: number;
}

/**
 * IMPRatingScore
 */
export class IMPRatingScore {
    val: number;
}

/**
 * MPRatingScore
 */
export class MPRatingScore implements IMPRatingScore {


    public static ZERO = new MPRatingScore(0);
    public static ONE = new MPRatingScore(1);
    public static TWO = new MPRatingScore(2);
    public static THREE = new MPRatingScore(3);
    public static FOUR = new MPRatingScore(4);
    public static FIVE = new MPRatingScore(5);

    public val: number;

    private constructor(value: number) {
        this.setRatingValue(value);
    }

    /**
     * getRatingFromNumber
     * @param num
     */
    public static getRatingFromNumber(num: number): MPRatingScore {
        if (num <= MPRatingScore.ZERO.getRatingValue()) {
            return MPRatingScore.ZERO;
        } else if (num >= MPRatingScore.FIVE.getRatingValue()) {
            return MPRatingScore.FIVE;
        } else {
            const rval = Math.round(num);
            return new MPRatingScore(rval);
        }
    }

    /**
     * Return a rating value to single decimal place
     * @param ratings
     */
    public static calculateWeightedAvgRating(ratings: IMPRating): number {
        let wavg = ratings.r1_count * MPRatingScore.ONE.getRatingValue() +
            ratings.r2_count * MPRatingScore.TWO.getRatingValue() +
            ratings.r3_count * MPRatingScore.THREE.getRatingValue() +
            ratings.r4_count * MPRatingScore.FOUR.getRatingValue() +
            ratings.r5_count * MPRatingScore.FIVE.getRatingValue();
        wavg = wavg / (ratings.r1_count + ratings.r2_count + ratings.r3_count + ratings.r4_count + ratings.r5_count);
        return Math.round(wavg * 10) / 10;
    }

    /**
     * setRatingValue
     * @param num
     * @private
     */
    private setRatingValue(num: number): void {
        if (num <= 0) {
            this.val = 0;
            return;
        } else if (num >= 5) {
            this.val = 5;
            return;
        } else {
            this.val = Math.round(num);
        }
    }

    /**
     * getRatingValue
     */
    public getRatingValue(): number {
        return this.val;
    }
}


/**
 * IMPRatingComment
 */
export interface IMPRatingComment extends IMPRatingScore {
    /**
     * comment string
     */
    comment: string;
    /**
     * comment timestamp
     */
    comment_dt: string;
}

/**
 * IMPLikeComment
 */
export interface IMPRatingComment extends IMPLike {
    /**
     * comment string
     */
    comment: string;
    /**
     * comment timestamp
     */
    comment_dt: string;
}

/**
 * IMPRatingCommentsMap
 */
// export interface IMPRatingCommentsMap {
//     /**
//      * unique uuid key
//      */
//     [commentId: string]: IMPRatingComment;
// }

/**
 * Media Asset
 */
export interface IMPMediaAsset {
    /**
     * url if content not present
     */
    mediaUrl: string;
    /**
     * field name for multi-part uploads
     */
    fieldName: string;
    /**
     * byte encoding
     */
    encoding: string;
    /**
     * mime type
     */
    mimeType: string;
    /**
     * content if url not present
     */
    content?: Buffer | string;
}

/**
 * Pricing Info
 */
interface IMPListingPricingInfo {
    /**
     * pricing option
     */
    pricingOptions: MP_LISTING_PRICING_OPTIONS;
    /**
     * pricing details
     */
    details: string;
}

export interface IMPListingStatusMap {
    /**
     * key=OrgId
     * This holds listing status for different orgs which are merged
     * e.g. If OrgId == managing Org it the status represents the listing lifecycle status
     * If OrgId == consuming Org then the status represents the listing lifecycle status of the consumer Org
     * This data is merged in this mapping based on information from managing org using its key GSBC Id
     * and then with the logged in user's Org GSBC Id. It is possible that user is from the managing org and
     * also consuming the listing so the status will host two states. Each status state is tied to an org type
     * * e.g {
     *   SUBSCRIBING_ORG_Id : Status && SUBSCRIBING_ORG_Id == logged in user Org Id
     *   PROVIDING_ORG_Id : Status
     *   LISTING_ORG_Id : Status
     *   }
     */
    [OrgId: string]: MP_LISTING_STATUS[];
}

/**
 * IMPListingMediaRef
 */
export interface IMPListingMediaRef {
    fieldName: string;
    mediaUrl: string;
}

/**
 * IMPListingAssetRef
 */
export interface IMPListingAssetRef {
    fieldName: string;
    assetName: string;
    isDownloadAvailable: boolean;
}

/**
 * Listing Object from GET marketplace/v1/contributions/<itemId>
 */
export interface IMPListing {
    listingId?: string;
    creatorAssetId?: string;
    /**
     * created asset id after GET - mainly for created apps from app templates
     */
    createdAssetId?: string;
    externallyManaged?: boolean;
    name?: string;
    version?: string;
    displayName?: string;
    description?: string;
    assetType?: string;
    appType?: string;
    tags?: string[];
    requestAccessUrl?: string;
    infoUrl?: string;
    eulaUrl?: string;
    priceMode?: string;
    priceDetail?: string;
    iconRef?: string;
    mediaRefs?: IMPListingMediaRef[];
    /**
     * Created Date timestamp
     */
    createdTime?: number;
    /**
     * Last Modified timestamp
     */
    lastUpdateTime?: number;
    /**
     * Certification timestamp
     */
    certifiedTime?: number;
    /**
     * managing org Id
     */
    providerGsbc?: string;
    /**
     * managing Org Name
     */
    providerName?: string;
    /**
     * hosting Org Id
     */
    hostingGsbc?: string;
    /**
     * Listing State
     */
    state?: MP_LISTING_STATE | string;
    /**
     * Listing Status - orgId/GSBC -> @TCI_MARKETPLACE_ORG_TYPE[]
     * managing org has different status states from the
     * consumer status states.
     * e.g {
     *   SUBSCRIBING_ORG_Id : Status && SUBSCRIBING_ORG_Id == logged in user Org Id
     *   PROVIDING_ORG_Id : Status
     *   LISTING_ORG_Id : Status
     *   }
     */
    aggregatedStatus?: IMPListingStatusMap;
    /**
     * Show upgrade version
     */
    nextVersion?: string;
    /**
     * number of pending access requests if the
     * @listingStatus[OrgId == managing Org] == @TCIMarketplaceListingStatus.PUBLICLY_AVAILABLE
     */
    numPendingAccessRequests?: number;
    /**
     * Rating counts
     */
    ratingInfo?: IMPRating;
    /**
     * endorsed By TIBCO
     */
    endorsed: boolean;
    /**
     * UI to show enabled without any actions button(Get/Request) if enabledByDefault:true
     * (This is essential for all OOTB bw/flogo connectors now and future)
     */
    enabledByDefault: boolean;
    /**
     * ref data
     */
    refData: any;
    /**
     * can delete or not
     */
    deletable: boolean;
    /**
     * asset refs
     */
    assetRef?: IMPListingAssetRef[];
}

export interface IMPResponse<T> {
    data?: T;
    status?: string;
    message?: string;
    success?: boolean;
}


/**
 * IMPListingAccess
 */
export interface IMPListingAccess {
    consumerGsbc?: string; // Subscription ID of the listing subscripted org
    consumerGsbcHash?: string; // consumer gsbc hash, the subscription locator
    listingId?: string; // This is the same ID in MarketplaceListings Table
    providerGsbc?: string; // 	Subscription ID of listing provider
    consumerName?: string; // 	Subscription Org Name
    // tslint:disable-next-line:max-line-length
    status?: string;	// 	enum: [Pending-Request, Request-Approved, Request-Rejected, Access-Revoked]	Listing status from Subscription Org perspective
    version?: string; // 	The consumer currently in use version, show upgrade if there's new version from provider
    requestTime?: number; // int64	Request access time
    requestUserId?: string; // Request access user ID
    requestUserEmail?: string; // Request access user email
    managingActionTime?: number; // Time of action taken by managing org, e.g. Approve, Reject etc
    managingActionUserId?: string; // User ID who takes managing action
    managingActionUserEmail?: string; // 	User email who takes managing action
    lastAccessAcknowledgedDate?: number; // last access action acknowledged date consumer only
    lastAccessAcknowledgedBy?: string; // last access action acknowledged by user id consumer only
    scribeOrgId?: string;  // Scribe org id
    getCount?: number;  // Not for UI, count/number of consumer get the listing
}

/**
 * IMPListingRequestResponse
 */
export interface IMPListingRequestResponse extends IMPResponse<IMPListing[]> {
}

/**
 * IMPListingActionResponse
 */
export interface IMPListingActionResponse extends IMPResponse<IMPListing[]> {
}

/**
 * IMPTagsRequestResponse
 */
export interface IMPTagsRequestResponse extends IMPResponse<string[]> {
}

/**
 * IMPRatingRequestResponse
 */
export interface IMPRatingRequestResponse extends IMPResponse<IMPRatingComment> {
}

/**
 * IMPLikeRequestResponse
 */
export interface IMPLikeRequestResponse extends IMPResponse<IMPLike[]> {
}

/**
 * IMPRatingAccessResponse
 */
export interface IMPListingAccessRequestResponse extends IMPResponse<IMPListingAccess[]> {
}
